export const PAYMENT_STATUS_META = {
  unpaid: { label: "Belum Bayar", badgeClass: "bg-amber-500/10 text-amber-600" },
  paid: { label: "Lunas", badgeClass: "bg-success/10 text-success" },
  refunded: { label: "Refund", badgeClass: "bg-muted text-muted-foreground" },
};

// Same vocabulary as the backend (PAYMENT_METHODS / PAYMENT_STATUSES in qr-backend/server.py).
export const PAYMENT_METHOD_LABELS = { cash: "Kasir", qris: "QRIS", transfer: "Transfer" };
export const PAYMENT_METHOD_OPTIONS = Object.keys(PAYMENT_METHOD_LABELS);

// Special value used by the order list filter tabs; not a real payment status.
export const UNPAID_FILTER = "unpaid";

export function getPaymentBadge(status) {
  return PAYMENT_STATUS_META[status] || PAYMENT_STATUS_META.unpaid;
}

export function getPaymentMethodLabel(method) {
  return PAYMENT_METHOD_LABELS[method] || PAYMENT_METHOD_LABELS.cash;
}

export function getPaymentStatus(order) {
  return order?.payment_status || "unpaid";
}

// Cancelled orders are never counted as receivable, even if never settled.
export function isOrderUnpaid(order) {
  return order?.status !== "cancelled" && getPaymentStatus(order) !== "paid";
}
